import { Form, Formik } from 'formik'

import { REGISTRAZIONE } from '../../utils/endpoint'
import Trans from '../../components/atomic/Trans'
import { api } from '../../utils'
import { schemaRecuperaPassword } from '../../components/registrazione/utils'
import { useState } from 'react'

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

const getFieldClass = (field, values, errors) => {
  return errors[field] ? 'error' : values[field] !== '' ? 'valid' : ''
}

const RecuperaPassword = () => {
  const [step, setStep] = useState(1)

  const recuperaPassword = async values => {
    api
      .post(REGISTRAZIONE + 'recupera_password/', { ...values })
      .then(() => setStep(2))
      .catch(error => console.log(error))
  }
  return (
    <main className="registrazione-page registrazione-page--recupera">
      <header className="registrazione-page__header">
        <div className="w-container">
          {/* <Breadcrumbs breadcrumbs={pagina.breadcrumbs} /> */}
          <h1 className="registrazione-page__title">
            <span>
              <Trans chiave="Recupera password" />
            </span>
          </h1>
          {step == 2 && (
            <div className="registrazione-page__description">
              <Trans chiave="Riceverai un'email per il reset della password" />
            </div>
          )}
        </div>
      </header>
      <section className="registrazione__form-section">
        <div className="container">
          <div className="registrazione-page__form-box">
            {step == 1 && (
              <Formik
                initialValues={{ email: '' }}
                validationSchema={schemaRecuperaPassword}
                onSubmit={(values, { resetForm }) => {
                  recuperaPassword(values).then(() => resetForm())
                }}
                enableReinitialize
              >
                {({ values, errors, dirty, isSubmitting, isValid, handleChange }) => (
                  <Form className="registrazione-page__form w-form">
                    <div className="row">
                      <div className="col-md-6 offset-md-3">
                        <div className="w-form__field-wrapper">
                          <input
                            type="text"
                            className={getFieldClass('email', values, errors)}
                            id="email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                          />
                          <label htmlFor="email">
                            <Trans chiave="Email*" />
                          </label>
                          <span className="w-form__error">{errors.email}</span>
                        </div>
                      </div>
                    </div>
                    <div className="registrazione-page__submit-box">
                      <input
                        type="submit"
                        value="Conferma"
                        disabled={!dirty || isSubmitting || !isValid}
                        className="registrazione-page__submit-button button button--primary"
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </div>
        </div>
      </section>
    </main>
  )
}

export default RecuperaPassword
